module.exports = __webpack_public_path__ + "img/9788930316422.ec499dda.jpg";